<mat-dialog-content>
    <div class="session-expiration-dialog">
        <div class="session-expiration-dialog-header">
            <h2 class="subhead dialog-title">Session Expiration</h2>
        </div>
        <div class="session-expiration-dialog-body">
            <p>Your session is about to expire. Would you like to stay logged in?</p>
            <div class="session-expiration-dialog-countdown-ctr">
                <app-countdown (completed)="expire()"></app-countdown>
            </div>
            <div class="session-expiration-dialog-actions">
                <button class="button-flat" (click)="signOut()">NO</button>
                <button class="button-flat" (click)="refreshSession()">YES</button>
            </div>
        </div>
    </div>
</mat-dialog-content>
